<div class="container my-component main-font" *ngIf="project">
  <div class="mb-4 mt-4" [ngClass]="{ 'ms-4': isMobile }">
    <div class="row pt-3">
      <div class="col-8">
        <h1 class="">
          <img
            [src]="
              utilityService.getSanitizeUrl(project?.filestorage.path ?? '')
            "
            alt="project"
            class="avatar rounded-circle" />
          {{ project?.alias }}
        </h1>
      </div>
      <!-- Start Gruppo 2 -->
      <div
        class="col-4 d-flex justify-content-end"
        *ngIf="teamcategory && !isBillingTable.getValue()">
        <p
          [ngClass]="{ invisible: isMobile }"
          class="d-flex align-items-center main-font px-3">
          {{ teamcategory.alias + ' ( ' + teamcategory.ideal_velocity + ' ) ' }}
        </p>
        <span
          [matTooltip]="
            teamcategory.alias + ' ( ' + teamcategory.ideal_velocity + ' ) '
          "
          matTooltipPosition="above">
          <button
            [disabled]="!is_authorized"
            data-bs-toggle="dropdown"
            mat-fab
            [matMenuTriggerFor]="typoMenu"
            color="white"
            class="border-1 border-solid"
            [ngStyle]="{ 'border-color': teamcategory.color_code }">
            <img
              [src]="
                utilityService.getSanitizeUrl(teamcategory.filestorage.path)
              "
              width="30"
              alt="teamcategory" />
          </button>
        </span>
        <mat-menu #typoMenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let typology of typologies"
            (click)="changeTypo(typology.id)"
            [disabled]="typology.id == teamcategory.id">
            <button
              mat-mini-fab
              color="white"
              class="rounded-circle border-1 border-solid shadow-none"
              [ngStyle]="{ 'border-color': typology.color_code }">
              <img
                [src]="utilityService.getSanitizeUrl(typology.filestorage.path)"
                width="25"
                alt="typology" />
            </button>
            {{ typology.alias + ' (' + typology.ideal_velocity + ')' }}
          </button>
        </mat-menu>
      </div>
      <!-- End Gruppo 2 -->
    </div>
    <!-- End title -->
    <div class="d-flex mt-3 row">
      <div
        class="d-flex flex-column align-items-start gap-2 align-items-md-center flex-md-row">
        <div *ngIf="is_authorized">
          <button
            class="me-2"
            mat-raised-button
            color="accent"
            data-bs-toggle="modal"
            data-bs-target="#modalSprint"
            *ngIf="!isLoading && !last_sprint?.id"
            (click)="isAddModal = true; _initSprintForm(); _initResidueForm()">
            Nuovo sprint
          </button>
        </div>

        <div *ngIf="!isBillingTable.getValue()" onkeydown="" class="col-6">
          <mat-chip-listbox [ngClass]="{ 'me-4': isMobile }">
            <mat-chip-option
              [ngClass]="getChipColorClass(chip)"
              *ngFor="let chip of statistic_type; index as i"
              selectable="false"
              [value]="chip"
              [selected]="chip === selectedChip"
              (click)="selectChip(chip)"
              class="my-2 my-md-0"
              >{{ chip }}
              <span class="badge" [ngClass]="getBadgeColorClass(chip)">
                {{ velocitaUltima[i] }}
              </span>
            </mat-chip-option>
          </mat-chip-listbox>
        </div>

        <mat-spinner
          *ngIf="isLoading"
          color="accent"
          diameter="20"></mat-spinner>

        <!-- bottone per visualizzare le due tabelle -->
        <div
          class="d-flex align-items-center justify-content-end"
          [ngClass]="isBillingTable.getValue() ? 'col-12' : 'col-6'"
          *ngIf="!isLoading || last_sprint?.id">
          <!-- scala story point -->
          <button
            nz-button
            class="text-center button-story-point d-flex me-3"
            data-bs-toggle="modal"
            data-bs-target="#spModal">
            <mat-icon class="me-2">trending_up</mat-icon> Scala SP
          </button>

          <button nz-button class="button-toggle" (click)="toggleBilling()">
            {{
              isBillingTable.getValue()
                ? 'Passa a Scrum'
                : 'Passa a fatturazione'
            }}
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <div *ngFor="let user of cerimonies">
          <div class="d-flex justify-content-end align-items-center gap-3">
            <div class="d-flex align-items-center justify-content-end my-2">
              <nz-input-number
                *ngIf="isScrum; else checkBox"
                [(ngModel)]="user.billing_value"
                [nzMin]="0"
                [nzStep]="0.25"
                [disabled]="!is_authorized"
                (input)="onInput($event)"
                keydown=""
                (ngModelChange)="
                  updateUserCapacity(dateNow, user.name, user.billing_value)
                ">
              </nz-input-number>

              <ng-template #checkBox>
                <label
                  nz-checkbox
                  [(ngModel)]="user.value"
                  (ngModelChange)="
                    updateUserCapacity(dateNow, user.name, 0, user.value)
                  "
                  [disabled]="
                    !is_authorized || user.billing_value !== 0
                  "></label>
              </ng-template>

              <img
                class="img-fluid ms-2"
                width="30px"
                height="30px"
                [src]="getImagePath(user.name)"
                nz-tooltip
                [nzTooltipTitle]="user.name"
                nzTooltipPlacement="bottom"
                [alt]="user.name" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-danger text-end">
        <p class="m-0">{{ errorMessage }}</p>
      </div>
    </div>
    <ng-template #noSprintMess>
      <div class="text-center">Nessuno sprint in corso</div>
    </ng-template>
    <div
      class="d-flex justify-content-between"
      *ngIf="sprint_data && !isBillingTable.getValue()"
      [class.readonly-container]="!is_authorized">
      <div class="col-12 scrumTable table-responsive">
        <table
          class="table text-nowrap table-borderless m-0"
          *ngIf="sprint_data[0]?.capacity; else noSprintMess">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-start col-2"
                [ngClass]="{ 'sticky-column': !isMobile }">
                <div class="d-flex align-items-center mb-2">
                  <!-- Pulsante di sinistra -->
                  <button
                    mat-button
                    style="min-width: 0px; margin-right: 0px"
                    [disabled]="isLeftButtonDisabled()"
                    (click)="selectPreviousSprint()">
                    <mat-icon style="margin-right: 0px">arrow_left</mat-icon>
                  </button>
                  <!-- Select sprint -->
                  <nz-select
                    nzShowSearch="true"
                    nzServerSearch="false"
                    [nzAllowClear]="false"
                    (nzOnSearch)="filteredSprints($event)"
                    nzPlaceHolder="Cerca sprint..."
                    [(ngModel)]="selectedSprint"
                    (ngModelChange)="changeSprint($event)"
                    nzNotFoundContent="Nessuno sprint corrispondente"
                    [nzOptionOverflowSize]="5">
                    <nz-option
                      *ngFor="let sprint of filteredSprints()"
                      [nzLabel]="'Sprint ' + sprint.number"
                      [nzValue]="sprint">
                    </nz-option>
                  </nz-select>
                  <!-- Pulsante di destra -->
                  <button
                    mat-button
                    style="min-width: 0px; margin-right: 0px"
                    [disabled]="isRightButtonDisabled()"
                    (click)="selectNextSprint()">
                    <mat-icon style="margin-right: 0px">arrow_right</mat-icon>
                  </button>
                  <!-- Pulsante tre puntini verticali e residuo -->
                  <div
                    class="d-flex align-items-center"
                    [ngClass]="{ invisible: is_authorized === false }">
                    <button
                      mat-button
                      style="min-width: 0px"
                      [matMenuTriggerFor]="dropdownMenu">
                      <mat-icon style="margin-right: 0px">more_vert</mat-icon>
                      <span
                        class="position-absolute start-100 translate-middle badge rounded-pill bg-danger"
                        style="top: -15px !important">
                        {{ residuePbi.length }}
                        <span class="visually-hidden">unread messages</span>
                      </span>
                    </button>
                    <mat-menu #dropdownMenu="matMenu">
                      <button
                        mat-menu-item
                        data-bs-toggle="modal"
                        data-bs-target="#modalSprint"
                        (click)="
                          stepper.reset();
                          isAddModal = true;
                          _initSprintForm();
                          _initResidueForm()
                        ">
                        <mat-icon>add</mat-icon>
                        Nuovo Sprint
                      </button>

                      <button
                        mat-menu-item
                        *ngIf="sprint_id"
                        color="accent"
                        data-bs-toggle="modal"
                        data-bs-target="#modalSprint"
                        (click)="
                          stepper.reset();
                          isAddModal = false;
                          _initSprintForm();
                          _initResidueForm();
                          onButtonClick()
                        "
                        [ngClass]="{ 'orange-icon': residuePbi.length > 0 }">
                        <mat-icon>list</mat-icon>
                        Residuo
                        <span
                          class="badge text-bg-danger"
                          *ngIf="residuePbi.length > 0"
                          >{{ residuePbi.length }}</span
                        >
                      </button>

                      <button
                        mat-menu-item
                        data-bs-toggle="modal"
                        data-bs-target="#modalTeamAssessment"
                        class="cursor-pointer align-middle"
                        matTooltip="Team assessment"
                        (click)="getAssessment()">
                        <img
                          src="/assets/images/team-assessment.svg"
                          alt=""
                          style="
                            background-size: cover;
                            width: 24px;
                            height: 24px;
                          " />
                        Team assessment
                      </button>

                      <button
                        mat-menu-item
                        *ngIf="sprint_id"
                        data-bs-toggle="modal"
                        data-bs-target="#modalSprint"
                        class="cursor-pointer align-middle me-2"
                        matTooltip="Modifica"
                        (click)="
                          stepper.reset();
                          isAddModal = false;
                          _initSprintForm();
                          _initResidueForm();
                          buttonClicked = false
                        ">
                        <mat-icon>edit</mat-icon>
                        Modifica Sprint
                      </button>

                      <button
                        mat-menu-item
                        *ngIf="selectedSprint.is_concluded == 1"
                        class="align-middle cursor-pointer"
                        matTooltip="Carica csv"
                        (click)="modalDocument()"
                        data-bs-toggle="modal"
                        data-bs-target="#saveDoc">
                        <mat-icon>download</mat-icon>
                        Carica CSV
                        <span
                          *ngIf="selectedSprint.has_csv == 1"
                          class="badge text-bg-danger"
                          >{{ selectedSprint.has_csv }}</span
                        >
                      </button>

                      <button
                        mat-menu-item
                        *ngIf="selectedSprint.is_concluded == 0"
                        data-bs-toggle="modal"
                        data-bs-target="#modalConclude"
                        class="cursor-pointer align-middle"
                        matTooltip="Concludi"
                        (click)="modalDocument()">
                        <mat-icon>sports_score</mat-icon>
                        Chiudi Sprint
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </th>
              <th
                scope="col"
                *ngFor="let day of sprint_data[0].capacity"
                [ngClass]="{
                  'last-th': day.is_total,
                  'current-day': day.date == currentDay
                }">
                <p
                  *ngIf="!day?.is_total"
                  class="m-0 m-custom text-center"
                  [ngClass]="{ 'bold-none': day.date != currentDay }"
                  nz-tooltip
                  [nzTooltipTitle]="day.date | date: 'dd-MM-YYYY'"
                  nzTooltipPlacement="top">
                  {{ day.date | date: 'dd-MM' }}
                </p>
                <div class="d-flex align-items-center justify-content-center">
                  <label
                    nz-checkbox
                    [(ngModel)]="day.is_daily_done"
                    [disabled]="!is_authorized || compareDate(day.date)"
                    (ngModelChange)="sendHoursToScrumMaster(day, 'Daily')"
                    control="daily"
                    [class.d-none]="day.is_total"
                    onkeydown=""
                    dailys>
                  </label>
                  <img
                    class="img-fluid"
                    width="30px"
                    height="30px"
                    src="assets/images/people.png"
                    nz-tooltip
                    [nzTooltipTitle]="'Daily'"
                    nzTooltipPlacement="right"
                    alt="daily"
                    [ngClass]="{ 'd-none': day.is_total }" />
                </div>
                <p *ngIf="day.is_total" class="m-custom">Totale</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of sprint_data">
              <th
                scope="row"
                class="bold-none"
                [ngClass]="{
                  highlight: highlightedUser === user.id,
                  'sticky-column': !isMobile
                }">
                <nz-row>
                  <nz-col>
                    {{ user.first_name + ' ' + user.last_name }}
                    <img
                      [matTooltip]="getEndWorkDate(user)"
                      *ngIf="isUserHighlighted(user)"
                      class="icon ms-2 mb-1"
                      src="assets/images/person_cancel.svg"
                      alt="delete" />
                  </nz-col>
                </nz-row>
              </th>
              <td
                *ngFor="let item of user?.capacity; let last = last"
                class="align-middle"
                [ngClass]="{ highlightRow: highlightedUser === user.id }">
                <input
                  class="data-scrum align-items-center"
                  (click)="highlightUser(user.id)"
                  type="number"
                  min="0"
                  [max]="item.billing_value"
                  (blur)="removeHighlight()"
                  [ngClass]="{
                    'current-day': item.date == focusDay,
                    'normal-day': item.date != focusDay,
                    'disabled-cell':
                      endWorkDate(user, item.date) || last || isLoading
                  }"
                  [matTooltip]="
                    isMobile ? user.first_name + ' ' + user.last_name : ''
                  "
                  [matTooltipDisabled]="!isMobile"
                  matTooltipPosition="right"
                  [(ngModel)]="item.value"
                  [placeholder]="user.is_capacity_per_days.value"
                  matInput
                  (ngModelChange)="
                    cellValueChangedCapacityForUsers(
                      item.id,
                      item.value,
                      item.billing_value
                    )
                  "
                  [disabled]="
                    endWorkDate(user, item.date) ||
                    last ||
                    isLoading ||
                    !is_authorized
                  " />
              </td>
            </tr>
            <tr class="total-row">
              <th
                scope="row"
                class="first-th last-th"
                [ngClass]="{ 'sticky-column': !isMobile }">
                {{ firstKeyrow }}
              </th>
              <td
                *ngFor="let item of totalCapacity[firstKeyrow]"
                class="align-middle">
                <input
                  class="data-scrum align-items-center total-data"
                  step="any"
                  [ngClass]="{
                    'current-day': item.date == currentDay,
                    'normal-day': item.date != currentDay
                  }"
                  [(ngModel)]="item.value"
                  matInput
                  type="number"
                  min="0"
                  max="8"
                  disabled />
              </td>
            </tr>
            <br />
            <tr>
              <th
                scope="row"
                class="btop-th"
                [ngClass]="{ 'sticky-column': !isMobile }">
                {{ secondKeyrow }}
              </th>
              <td
                *ngFor="let item of totalCapacity[secondKeyrow]"
                class="align-middle">
                <input
                  class="data-scrum align-items-center"
                  step="any"
                  [ngClass]="{
                    'current-day': item.date == focusDay,
                    'normal-day': item.date != focusDay
                  }"
                  [(ngModel)]="item.value"
                  matInput
                  type="number"
                  min="0"
                  max="8"
                  disabled />
              </td>
            </tr>
            <tr>
              <th
                class=""
                scope="row"
                [ngClass]="{
                  highlighted: highlight === thirdKeyrow,
                  'sticky-column': !isMobile
                }">
                {{ thirdKeyrow }}
              </th>
              <td
                *ngFor="let item of totalCapacity[thirdKeyrow]; let i = index"
                class="align-middle"
                [ngClass]="{ highlightRow: highlight === thirdKeyrow }">
                <input
                  (keyup)="onInputKeyUp(item.id, item.value)"
                  (click)="highlighted(thirdKeyrow)"
                  [matTooltip]="isMobile ? 'SP programmati' : ''"
                  [matTooltipDisabled]="!isMobile"
                  matTooltipPosition="right"
                  (blur)="removeHighlighted()"
                  class="data-scrum align-items-center"
                  step="any"
                  [ngClass]="{
                    'current-day': item.date == focusDay,
                    'normal-day': item.date != focusDay
                  }"
                  [(ngModel)]="item.value"
                  matInput
                  type="number"
                  min="0"
                  (ngModelChange)="
                    cellValueChangedCapacityStatistic(item.id, item.value)
                  "
                  [disabled]="isLoading" />
              </td>
            </tr>
            <tr>
              <th
                class=""
                scope="row"
                [ngClass]="{
                  highlighted: highlight === fourthKeyrow,
                  'sticky-column': !isMobile
                }">
                {{ fourthKeyrow }}
              </th>
              <td
                *ngFor="let item of totalCapacity[fourthKeyrow]; let i = index"
                class="align-middle"
                [ngClass]="{ highlightRow: highlight === fourthKeyrow }">
                <input
                  (keyup)="
                    onInputKeyUp2(
                      item.id,
                      item.value,
                      totalCapacity[thirdKeyrow][i].value
                    )
                  "
                  (click)="highlighted(fourthKeyrow)"
                  [matTooltip]="isMobile ? 'SP rimanenti' : ''"
                  [matTooltipDisabled]="!isMobile"
                  matTooltipPosition="right"
                  (blur)="removeHighlighted()"
                  class="data-scrum align-items-center"
                  step="any"
                  [ngClass]="{
                    'current-day': item.date == focusDay,
                    'normal-day': item.date != focusDay
                  }"
                  [(ngModel)]="item.value"
                  matInput
                  type="number"
                  min="0"
                  [max]="totalCapacity[thirdKeyrow][i].value"
                  (ngModelChange)="
                    cellValueChangedCapacityStatistic2(
                      item.id,
                      item.value,
                      totalCapacity[thirdKeyrow][i].value
                    )
                  "
                  [disabled]="isLoading" />
              </td>
            </tr>

            <ng-container *ngIf="selectedChip === 'Cliente'">
              <tr class="velocity-cliente">
                <th
                  scope="row"
                  class="align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ fifthKeyrow }} <span class="badge float-end">C</span>
                </th>
                <td *ngFor="let item of spC" class="align-middle">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="selectedChip === 'Interno'">
              <tr class="velocity-interno">
                <th
                  scope="row"
                  class="align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ fifthKeyrow }} <span class="badge float-end">I</span>
                </th>
                <td *ngFor="let item of spI" class="align-middle">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="selectedChip === 'Team'">
              <tr class="velocity-team">
                <th
                  scope="row"
                  class="align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ fifthKeyrow }} <span class="badge float-end">T</span>
                </th>
                <td *ngFor="let item of spT" class="align-middle">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="selectedChip === 'Cliente'">
              <tr class="velocity-cliente">
                <th
                  scope="row"
                  class="last-th align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ sixthKeyrow }} <span class="badge float-end">C</span>
                </th>
                <td *ngFor="let item of velC" class="align-middle velocity-td">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                  <span class="velocity-icon">
                    <mat-icon
                      [ngClass]="{
                        'text-danger': item.value < teamcategory.ideal_velocity,
                        'text-success':
                          item.value > teamcategory.ideal_velocity,
                        'text-secondary':
                          item.value == teamcategory.ideal_velocity
                      }">
                      {{
                        item.value > teamcategory.ideal_velocity
                          ? 'arrow_drop_up'
                          : item.value == teamcategory.ideal_velocity
                            ? 'remove'
                            : 'arrow_drop_down'
                      }}
                    </mat-icon>
                  </span>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="selectedChip === 'Interno'">
              <tr class="velocity-interno">
                <th
                  scope="row"
                  class="last-th align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ sixthKeyrow }} <span class="badge float-end">I</span>
                </th>
                <td *ngFor="let item of velI" class="align-middle velocity-td">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                  <span class="velocity-icon">
                    <mat-icon
                      [ngClass]="{
                        'text-danger': item.value < teamcategory.ideal_velocity,
                        'text-success':
                          item.value > teamcategory.ideal_velocity,
                        'text-secondary':
                          item.value == teamcategory.ideal_velocity
                      }">
                      {{
                        item.value > teamcategory.ideal_velocity
                          ? 'arrow_drop_up'
                          : item.value == teamcategory.ideal_velocity
                            ? 'remove'
                            : 'arrow_drop_down'
                      }}
                    </mat-icon>
                  </span>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="selectedChip === 'Team'">
              <tr class="velocity-team">
                <th
                  scope="row"
                  class="last-th align-bottom"
                  [ngClass]="{ 'sticky-column': !isMobile }">
                  {{ sixthKeyrow }} <span class="badge float-end">T</span>
                </th>
                <td *ngFor="let item of velT" class="align-middle velocity-td">
                  <input
                    class="data-scrum align-items-center change-data"
                    step="any"
                    [ngClass]="{
                      'current-day': item.date == currentDay,
                      'normal-day': item.date != currentDay
                    }"
                    [(ngModel)]="item.value"
                    matInput
                    type="number"
                    min="0"
                    disabled />
                  <span class="velocity-icon">
                    <mat-icon
                      [ngClass]="{
                        'text-danger': item.value < teamcategory.ideal_velocity,
                        'text-success':
                          item.value > teamcategory.ideal_velocity,
                        'text-secondary':
                          item.value == teamcategory.ideal_velocity
                      }">
                      {{
                        item.value > teamcategory.ideal_velocity
                          ? 'arrow_drop_up'
                          : item.value == teamcategory.ideal_velocity
                            ? 'remove'
                            : 'arrow_drop_down'
                      }}
                    </mat-icon>
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="isBillingTable.getValue()">
      <app-scrum-billing
        [data]="billing_data"
        [sprints]="sprints"
        [selectedSprint]="selectedSprint"
        [is_authorized]="is_authorized"
        (sprintIdEmit)="getBillingSprint($event)"
        [totalCapacity]="totalCapacity"
        [currentIndex]="currentIndex">
      </app-scrum-billing>
    </div>
    <!-- GRAFICI -->
    <div *ngIf="!isBillingTable.getValue()">
      <div class="d-flex flex-wrap mt-3" style="padding-bottom: 50px">
        <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
          <canvas
            id="evolChart"
            [ngStyle]="{ 'width.px': isMobile ? 'auto' : 390 }"></canvas>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12" style="padding-left: 15px">
          <canvas
            id="capChart"
            [ngStyle]="{ 'width.px': isMobile ? 'auto' : 370 }"></canvas>
        </div>
      </div>
    </div>
  </div>
  <!-- Modale sprint -->
  <div
    class="modal fade modal-lg"
    id="modalSprint"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalSprintLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h1 class="modal-title fs-5" id="modalSprintLabel">
            {{ isAddModal ? 'Nuovo sprint' : 'Sprint ' + sprint_num }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="
              buttonClicked = false;
              _initSprintForm();
              _initResidueForm();
              showCsvStep = false;
              showResidueStep = false
            "></button>
        </div>
        <div class="modal-body">
          <mat-stepper #stepper color="accent" labelPosition="end" class="mt-3">
            <!-- CSV -->
            <mat-step *ngIf="showCsvStep" [stepControl]="csvDataForm">
              <ng-template matStepLabel>Inserimento CSV</ng-template>
              <form [formGroup]="csvDataForm" class="d-flex align-items-center">
                <mat-checkbox formControlName="isPilot" class="me-auto"
                  >Opzione Pilota</mat-checkbox
                >

                <mat-form-field
                  appearance="fill"
                  color="primary"
                  class="flex-1 ms-3"
                  floatLabel="always">
                  <mat-label class="site-font">Carica documento</mat-label>
                  <input
                    [attr.type]="'file'"
                    #fileInput
                    formControlName="csvFile"
                    matInput
                    required
                    hidden
                    (change)="onFileSelected($event)"
                    accept=".csv" />
                  <mat-icon
                    class="download cursor-pointer"
                    matSuffix
                    (click)="fileInput.click()"
                    onkeydown=""
                    >folder_open</mat-icon
                  >
                  <span class="file-name">{{ selectedFileName }}</span>
                </mat-form-field>
              </form>

              <div class="float-end pt-4 ms-2">
                <button
                  type="button"
                  mat-raised-button
                  color="accent"
                  (click)="insertCSV()"
                  matStepperNext>
                  Successivo
                </button>
              </div>
              <div class="float-end pt-4">
                <button type="submit" mat-raised-button matStepperNext>
                  Salta
                </button>
              </div>
            </mat-step>

            <!-- Residuo -->
            <mat-step *ngIf="!isAddModal || showCsvStep">
              <ng-template matStepLabel>Residuo</ng-template>
              <button
                *ngIf="!isAddModal"
                class="mb-3"
                mat-raised-button
                color="accent"
                (click)="addNewRow()"
                mat-button>
                Aggiungi pbi residuo
              </button>
              <ng-template #noResidueMess>
                <div class="text-center">Nessun residuo presente</div>
              </ng-template>
              <div
                class="scrumTable table-responsive"
                *ngIf="residueFormArray.value.length != 0; else noResidueMess">
                <form [formGroup]="residueForm">
                  <table
                    formArrayName="residues"
                    class="table table-borderless m-0">
                    <thead>
                      <tr>
                        <th
                          *ngFor="
                            let day of columnHeadersModal;
                            let first = first;
                            let last = last
                          "
                          [class.first-th]="first"
                          [class.last-th]="last"
                          class="col-3 text-center maxW">
                          {{ day }}
                        </th>
                      </tr>
                      <tr></tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let item of residueFormArray.controls;
                          index as rowIndex
                        "
                        [formGroupName]="rowIndex">
                        <td class="align-middle">
                          <input
                            class="data-scrum align-items-center normal-day isLess"
                            formControlName="pbi_code"
                            matInput
                            type="number" />
                        </td>
                        <td class="align-middle text-center">
                          <input
                            class="data-scrum align-items-center normal-day"
                            formControlName="original_effort"
                            matInput
                            type="number"
                            step="1"
                            min="0"
                            max="21" />
                        </td>
                        <td class="align-middle">
                          <input
                            class="data-scrum align-items-center normal-day"
                            formControlName="done_percentage"
                            matInput
                            type="number"
                            step="any"
                            min="0"
                            max="100" />
                        </td>
                        <td class="align-middle">
                          <input
                            class="data-scrum align-items-center normal-day"
                            formControlName="current_effort"
                            matInput
                            type="number"
                            step="any"
                            min="0"
                            max="21" />
                        </td>
                        <td class="align-middle">
                          <mat-form-field
                            matTooltip="Seleziona data completamento"
                            appearance="fill"
                            color="accent"
                            class="picker_pos custom-height no-underline">
                            <input
                              [min]="selectedSprint.start_date"
                              [max]="selectedSprint.end_date"
                              matInput
                              height="50"
                              [matDatepicker]="picker"
                              formControlName="is_done" />
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                        </td>
                        <td class="align-middle text-center">
                          <mat-icon
                            class="cursor-pointer me-1"
                            *ngIf="item.get('is_done')?.value !== null"
                            mat-icon-button
                            matSuffix
                            (click)="clearDate(rowIndex)"
                            matTooltip="Rimuovi data completamento"
                            >clear</mat-icon
                          >

                          <mat-icon
                            (click)="removeRow(item.value.id)"
                            matTooltip="Elimina residuo"
                            class="cursor-pointer"
                            >delete</mat-icon
                          >
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p>Totale</p>
                        </td>
                        <td>
                          <p class="data-scrum normal-day">
                            {{
                              current_original_effort
                                ? current_original_effort
                                : 0
                            }}
                            {{
                              dataTotal?.original_effort
                                ? '/' + dataTotal?.original_effort
                                : ''
                            }}
                          </p>
                        </td>
                        <td>
                          <p class="data-scrum normal-day">
                            {{
                              dataTotal?.done_percentage
                                ? dataTotal?.done_percentage
                                : 0
                            }}
                          </p>
                        </td>
                        <td class="">
                          <p class="data-scrum normal-day sizeP">
                            {{
                              current_effort_reale ? current_effort_reale : 0
                            }}
                            {{
                              dataTotal?.current_effort
                                ? '/' + dataTotal?.current_effort
                                : ''
                            }}
                          </p>
                        </td>
                        <td class="justify-content-center w-100 d-flex">
                          <p class="data-scrum normal-day">
                            {{ dataTotal?.is_done ? dataTotal?.is_done : 0 }}
                            {{
                              residuePbi.length ? '/' + residuePbi.length : ''
                            }}
                          </p>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
              <div class="float-end pt-4">
                <div class="col-12">
                  <span
                    class="me-2 small disable-gray"
                    *ngIf="residueFormArray.pristine"
                    >I totali verranno aggiornati al salvataggio</span
                  >
                </div>
                <br />

                <button
                  type="button"
                  mat-raised-button
                  matStepperPrevious
                  class="me-2">
                  Indietro
                </button>
                <button
                  type="button"
                  mat-raised-button
                  color="accent"
                  class="me-2"
                  [disabled]="
                    isAddModal
                      ? false
                      : residueFormArray.pristine || residueFormArray.invalid
                  "
                  (click)="isAddModal ? null : saveResiduePbi()"
                  matStepperNext>
                  {{ isAddModal ? 'Successivo' : 'Salva residui' }}
                </button>
              </div>
            </mat-step>

            <!-- Generale -->
            <mat-step
              *ngIf="!buttonClicked"
              [stepControl]="generalData"
              errorMessage="Le date sono obbligatorie">
              <ng-template matStepLabel>Sprint</ng-template>
              <form [formGroup]="generalData" class="mt-3">
                <div class="d-flex justify-content-start">
                  <mat-form-field
                    appearance="fill"
                    color="accent"
                    class="col-5">
                    <mat-label>Data inizio - Data fine</mat-label>
                    <mat-date-range-input
                      [rangePicker]="picker"
                      [dateFilter]="datePickerFilter">
                      <input
                        matStartDate
                        placeholder="Start date"
                        formControlName="start_date"
                        (dateChange)="resetDaysOff(calendar)" />
                      <input
                        matEndDate
                        placeholder="End date"
                        formControlName="end_date"
                        (dateChange)="resetDaysOff(calendar)" />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>

                  <div
                    class="mt-2 mx-5"
                    (click)="isVisible = !isVisible"
                    onkeydown="">
                    <span class="pDaysOff">
                      {{ daysSelected.length }} Days off
                    </span>
                    <button
                      mat-mini-fab
                      class="ms-1 align-middle"
                      [matMenuTriggerFor]="appMenu"
                      [disabled]="generalData.invalid">
                      <mat-icon>today</mat-icon>
                    </button>
                  </div>

                  <mat-menu #appMenu="matMenu" class="drop-calendar">
                    <div (click)="$event.stopPropagation()" onkeydown="">
                      <mat-calendar
                        #calendar
                        (selectedChange)="select($event, calendar, false)"
                        [dateClass]="isSelected"
                        [minDate]="
                          this.generalData.controls['start_date'].value
                        "
                        [maxDate]="
                          this.generalData.controls['end_date'].value
                        "></mat-calendar>
                    </div>
                  </mat-menu>
                </div>
              </form>

              <mat-chip-listbox class="align-items-center" *ngIf="isVisible">
                <mat-chip-row
                  class="mx-2 bg-light cursor-default"
                  *ngFor="let day of daysSelected"
                  (removed)="select(day, calendar, true)">
                  {{ day }}
                  <button matChipRemove aria-label="Rimuovi">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-listbox>

              <div class="float-end pt-4">
                <button
                  type="submit"
                  mat-raised-button
                  color="accent"
                  matStepperNext>
                  Successivo
                </button>
              </div>
            </mat-step>

            <!-- Team capacity -->
            <mat-step
              *ngIf="!buttonClicked"
              [stepControl]="capacityData"
              errorMessage="Capacity team obbligatoria">
              <ng-template matStepLabel>Team</ng-template>
              <form [formGroup]="capacityData" class="mt-3">
                <div class="d-flex flex-column">
                  <div class="row">
                    <div class="col-6 d-flex">
                      <mat-form-field color="accent" class="col-10">
                        <mat-label>Team category</mat-label>
                        <mat-select formControlName="team_category">
                          <mat-option
                            *ngFor="let typology of typologies"
                            [value]="typology.id"
                            (click)="changeTypoImg(typology)">
                            {{
                              typology.alias +
                                ' (' +
                                typology.ideal_velocity +
                                ')'
                            }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button
                        *ngIf="modalTypoImg"
                        mat-fab
                        color="white"
                        class="ms-2 border-1 border-solid cursor-default"
                        disableRipple
                        [ngStyle]="{ 'border-color': modalTypoImg.color_code }">
                        <img
                          [src]="
                            utilityService.getSanitizeUrl(modalTypoImg.path)
                          "
                          alt="Team Capacity"
                          width="30" />
                      </button>
                    </div>

                    <div
                      class="col-6 d-flex justify-content-end align-items-center">
                      <p class="m-0 me-3">Durata media daily</p>

                      <nz-input-number
                        [(ngModel)]="daily_time"
                        [nzMin]="0"
                        [nzMax]="8"
                        [nzStep]="0.25"
                        formControlName="daily_time"
                        [disabled]="!is_authorized"></nz-input-number>
                      <img
                        class="img-fluid"
                        width="30px"
                        height="30px"
                        src="assets/images/people.png"
                        nz-tooltip
                        [nzTooltipTitle]="'Daily'"
                        nzTooltipPlacement="top"
                        alt="daily" />
                    </div>
                  </div>

                  <div class="col-12 py-2 px-4 text-center">
                    <span class="fw-bold"
                      >Ricorda che il valore di fatturazione deve essere
                      maggiore o uguale al valore della capacity</span
                    >
                  </div>

                  <div class="scrumTable col-12 table-responsive">
                    <table class="table table-borderless m-0">
                      <thead>
                        <tr>
                          <th class="col-4 first-th">User</th>
                          <th class="col-4 text-center">
                            Fatturazione giornaliera
                            {{ !isAddModal ? ' per i giorni rimanenti' : '' }}
                          </th>
                          <th class="col-3 text-center">
                            Capacity giornaliera
                            {{ !isAddModal ? ' per i giorni rimanenti' : '' }}
                          </th>
                          <th class="col-1 last-th"></th>
                        </tr>
                      </thead>
                      <tbody *ngIf="availableUsers$.value; else updateData">
                        <ng-container formArrayName="team_member">
                          <tr
                            *ngFor="
                              let user of availableUsers$.value;
                              index as i
                            ">
                            <td class="col-4 align-middle">
                              {{ user.first_name + ' ' + user.last_name }}
                            </td>
                            <td class="align-middle col-3" [formGroupName]="i">
                              <input
                                class="data-scrum text-center normal-day"
                                [value]="user.billing_value"
                                type="number"
                                min="0"
                                max="8"
                                [step]="0.25"
                                formControlName="billing_value"
                                (input)="onInput($event)" />
                            </td>

                            <td class="align-middle col-3" [formGroupName]="i">
                              <input
                                [ngClass]="{
                                  'disabled-cell':
                                    user.role === 11 || user.role === 12
                                }"
                                [disabled]="
                                  user.role === 11 || user.role === 12
                                "
                                class="data-scrum text-center normal-day"
                                [value]="user.value"
                                type="number"
                                min="0"
                                max="8"
                                formControlName="value"
                                [step]="0.25"
                                (input)="onInput($event)" />
                            </td>

                            <td>
                              <button
                                *ngIf="sprint_num >= last_sprint?.number"
                                [disabled]="availableUsers$.value.length <= 1"
                                class="bg-transparent border-0"
                                (click)="
                                  deleteUser(
                                    $event,
                                    user.project_user_id,
                                    this.generalData.controls['start_date']
                                      .value,
                                    this.generalData.controls['end_date'].value,
                                    user.first_name + ' ' + user.last_name
                                  )
                                "
                                (keydown)="
                                  deleteUser(
                                    $event,
                                    user.project_user_id,
                                    this.generalData.controls['start_date']
                                      .value,
                                    this.generalData.controls['end_date'].value,
                                    user.first_name + ' ' + user.last_name
                                  )
                                ">
                                <img
                                  [ngClass]="{
                                    'disabled-icon':
                                      availableUsers$.value.length <= 1
                                  }"
                                  class="icon"
                                  src="assets/images/Shared/delete.svg"
                                  alt="delete" />
                              </button>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                      <ng-template #updateData>
                        <tbody *ngIf="sprint_data">
                          <ng-container formArrayName="team_member">
                            <tr
                              *ngFor="
                                let user of capacityData?.get('team_member')[
                                  'controls'
                                ];
                                index as i
                              ">
                              <td>
                                {{
                                  capacityData?.get('team_member').at(i).value
                                    .first_name +
                                    ' ' +
                                    capacityData?.get('team_member').at(i).value
                                      .last_name
                                }}
                              </td>
                              <ng-container>
                                <td class="align-middle" [formGroupName]="i">
                                  <input
                                    class="data-scrum text-center normal-day"
                                    matInput
                                    type="number"
                                    min="0"
                                    max="8"
                                    formControlName="value" />
                                </td>
                              </ng-container>
                            </tr>
                          </ng-container>
                        </tbody>
                      </ng-template>
                    </table>
                  </div>
                </div>

                <div class="float-end pt-4">
                  <button
                    type="button"
                    mat-raised-button
                    class="me-2"
                    matStepperPrevious>
                    Indietro
                  </button>
                  <button
                    type="submit"
                    mat-raised-button
                    color="accent"
                    data-bs-dismiss="modal"
                    [disabled]="generalData.invalid || capacityData.invalid"
                    (click)="saveSprint(); stepper.reset()">
                    Salva
                  </button>
                </div>
              </form>
            </mat-step>
          </mat-stepper>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal modal-md"
    id="modalConclude"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalConcludeLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h1 class="modal-title fs-5" id="modalConcludeLabel">
            Concludi Sprint
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="mb-4">
            Sei sicuro di voler impostare questo Sprint come concluso?
          </p>
          <div class="d-flex justify-content-end">
            <button
              class="me-2 cursor-pointer align-middle end-sprint-btn"
              data-bs-toggle="modal"
              data-bs-dismiss="modal">
              Annulla
            </button>
            <button
              class="me-2 cursor-pointer align-middle end-sprint-btn"
              data-bs-toggle="modal"
              data-bs-target="#modalSprint"
              (click)="concludeSprint()">
              Conferma
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODALE AGGIUNTA CSV -->
<div
  class="modal fade"
  id="saveDoc"
  tabindex="-1"
  aria-labelledby="saveDocLabel"
  data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <h1 id="saveDoc" class="modal-title fs-5 px-2 py-3">
          Aggiungi nuovo documento CSV
        </h1>
        <form
          [formGroup]="csvDataForm"
          class="d-flex align-items-center mt-3 row">
          <mat-checkbox
            formControlName="isPilot"
            class="col-6"
            [disabled]="this.csvDataForm.value.isBilling"
            >Opzione Pilota</mat-checkbox
          >

          <mat-checkbox
            formControlName="isBilling"
            class="col-6"
            [disabled]="csvDataForm.value.isPilot"
            >Sprint fatturazione</mat-checkbox
          >
          <mat-form-field
            appearance="fill"
            color="primary"
            class="flex-1 col-12 mt-2 w-100"
            floatLabel="always">
            <mat-label class="site-font w-100">Carica documento</mat-label>
            <input
              [attr.type]="'file'"
              class="w-100"
              #fileInput
              formControlName="csvFile"
              matInput
              required
              hidden
              (change)="onFileSelected($event)"
              accept=".csv" />
            <mat-icon
              class="download cursor-pointer"
              matSuffix
              (click)="fileInput.click()"
              [class.disabled]="csvDataForm.value.isBilling"
              onkeydown=""
              >folder_open</mat-icon
            >
            <span class="file-name">{{ selectedFileName }}</span>
          </mat-form-field>
        </form>
        <div class="modal-footer">
          <button type="button" mat-raised-button data-bs-dismiss="modal">
            Annulla
          </button>
          <button
            [disabled]="!csvDataForm.valid"
            mat-raised-button
            data-bs-dismiss="modal"
            color="accent"
            (click)="csvDataForm.value.isBilling ? setHasCSV() : insertCSV()">
            Salva
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL TEAM ASSESSMENT -->
<div
  class="modal fade"
  id="modalTeamAssessment"
  tabindex="-1"
  aria-labelledby="addLearnedModalLabel"
  data-bs-backdrop="static"
  aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1
          class="modal-title fs-4 main-font primary-color"
          id="addLearnedModal">
          Sommario Retrospettiva
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="
            teamAssessmentForm.reset(); teamAssessmentFormHeader.reset()
          "></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="teamAssessmentFormHeader">
          <div class="card mb-3">
            <div class="card-body card1">
              <div class="row mb-3">
                <div class="col-md-5 space-data">
                  <mat-form-field
                    appearance="fill"
                    color="accent"
                    class="w-100 main-font">
                    <mat-label
                      >Data ultimo giorno dello sprint
                      {{ sprintNumberSelected }}</mat-label
                    >
                    <input
                      matInput
                      [matDatepicker]="picker2"
                      formControlName="date"
                      [readonly]="true"
                      required />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker2"
                      [disabled]="true"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-md-6 pos">
                  <div class="row s-top">
                    <div class="col-6 align-content-center">
                      <p class="mb-0">Partecipanti totali</p>
                    </div>
                    <div class="col-2">
                      <input
                        formControlName="total"
                        class="normal-day form-control input_assessment border-0 input-small"
                        type="number"
                        id="modalInput"
                        min="0"
                        value="0"
                        required />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <p class="title">Contributi</p>
              <div class="col-md-12">
                <div class="row mb-2">
                  <div class="col-3 space-border">
                    <p class="mb-0">Partecipanti votanti</p>
                  </div>
                  <div class="col-2">
                    <input
                      class="data-scrum form-control input_assessment border-0 input-small"
                      formControlName="voting"
                      type="number"
                      id="modalInputPartecipanti"
                      min="0"
                      value="0"
                      required />
                  </div>

                  <div class="col-3 space-border">
                    <p class="mb-0">Feedback creati</p>
                  </div>
                  <div class="col-2">
                    <input
                      class="form-control input_assessment border-0 input-small"
                      formControlName="feedback"
                      type="number"
                      id="modalInput"
                      min="0"
                      value="0"
                      required />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="card mb-3">
          <form [formGroup]="teamAssessmentForm">
            <div class="card-body row">
              <div class="col-4">
                <p class="title">Team Assessment</p>
              </div>
              <div class="col-9">
                <div class="row mb-3 info-title">
                  <div class="col-3 label-assassment">
                    <p class="mb-0 text-center info-as">Sfavorevole %</p>
                  </div>
                  <div class="col-3 label-assassment">
                    <p class="mb-0 ms-2 text-center info-as">Neutrale %</p>
                  </div>
                  <div class="col-3 label-assassment">
                    <p class="mb-0 ms-1 text-center info-as">Favorevole %</p>
                  </div>
                  <div class="col-3 media label-assassment">
                    <p class="mb-0 ms-3 text-center info-as">Media</p>
                  </div>
                </div>
              </div>

              <div formArrayName="assessments">
                <div
                  *ngFor="let item of assessments.controls; let i = index"
                  [formGroupName]="i"
                  class="assessment-table d-flex align-items-center mb-3">
                  <div class="col-4 d-flex align-items-center">
                    <ng-container [ngSwitch]="item.get('label')?.value">
                      <img
                        *ngSwitchCase="'Work-life Balance'"
                        src="assets/images/balanced.svg"
                        alt="Work-life Balance"
                        class="me-1 assessment-icon" />
                      <img
                        *ngSwitchCase="'Clarity'"
                        src="assets/images/search.svg"
                        alt="Clarity"
                        class="me-1 assessment-icon" />
                      <img
                        *ngSwitchCase="'Efficiency'"
                        src="assets/images/manufacturing.svg"
                        alt="Efficiency"
                        class="me-1 assessment-icon" />
                      <img
                        *ngSwitchCase="'Psychological Safety'"
                        src="assets/images/handshake_asse.svg"
                        alt="Psychological Safety"
                        class="me-1 assessment-icon" />
                      <img
                        *ngSwitchCase="'Energy'"
                        src="assets/images/bolt.svg"
                        alt="Energy"
                        class="me-1 assessment-icon" />
                      <img
                        *ngSwitchCase="'Confidence'"
                        src="assets/images/insert_chart.svg"
                        alt="Confidence"
                        class="me-1 assessment-icon" />
                    </ng-container>
                    <p class="mb-0">{{ item.get('label')?.value }}</p>
                    <img
                      src="assets/images/info.svg"
                      alt="info"
                      [nz-tooltip]="item.get('info')?.value"
                      class="icon-info ms-1" />
                    <p
                      class="text-danger asterisk mb-0 ms-1"
                      *ngIf="
                        isAssessmentInvalid(i) &&
                        (votes(i).touched || votes(i).dirty)
                      ">
                      *
                    </p>
                  </div>
                  <div formArrayName="votes" class="row">
                    <div
                      class="d-flex align-items-center"
                      *ngFor="let vote of votes(i).controls; let j = index"
                      [formGroupName]="j">
                      <input
                        (input)="manageAssessment(i, j)"
                        class="form-control input_assessment mx-3 input-red"
                        type="number"
                        formControlName="sfavorevole"
                        min="0"
                        max="100"
                        step="0.1" />
                      <input
                        (input)="manageAssessment(i, j)"
                        class="form-control input_assessment mx-3 input-yellow"
                        type="number"
                        formControlName="neutrale"
                        min="0"
                        max="100"
                        step="0.1" />
                      <input
                        (input)="manageAssessment(i, j)"
                        class="form-control input_assessment mx-3 input-green"
                        type="number"
                        formControlName="favorevole"
                        min="0"
                        max="100"
                        step="0.1" />
                      <input
                        (input)="
                          onInputAssement(votes(i).controls[j].value, i, j)
                        "
                        class="form-control input_assessment mx-3 input-none"
                        type="number"
                        formControlName="media"
                        min="0"
                        max="10"
                        step="0.1" />
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-danger" [ngClass]="{ 'opacity-0': !isLess }">
                * La somma delle 3 percentuali deve essere 100
              </p>
            </div>
          </form>
        </div>

        <div class="d-flex justify-content-end">
          <button
            type="button"
            mat-raised-button
            data-bs-dismiss="modal"
            class="main-font"
            (click)="
              this.teamAssessmentForm.reset();
              this.teamAssessmentFormHeader.reset()
            ">
            Chiudi
          </button>
          <button
            type="button"
            [disabled]="
              teamAssessmentForm.invalid || teamAssessmentFormHeader.invalid
            "
            mat-raised-button
            color="accent"
            class="main-font ms-2"
            (mouseup)="saveTeamAssessment()">
            Salva
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modale-story-points></app-modale-story-points>
